import Api from 'api';

import {
  SET_INPC_PAGINATION,
  SET_INPC_FILTERS,
  GET_INPC,
  RESET_INPC_LIST,
  RESET_INPC_FORM,
  GET_INPC_BY_ID,
  MODIFY_EDITING_INPC,
  ADD_INPC,
  UPDATE_INPC,
} from 'inpc/constants';

export const setPagination = (payload) => ({
  type: SET_INPC_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_INPC_FILTERS,
  payload,
});

export const getInpc = (companyId, filters, limit, page, orderBy, order) => ({
  type: GET_INPC,
  meta: { needAuth: true },
  payload: Api.inpc.get(companyId, filters, limit, page, orderBy, order),
});

export const resetList = () => ({ type: RESET_INPC_LIST });

export const resetForm = () => ({ type: RESET_INPC_FORM });

export const getInpcById = (inpcId, companyId, subcompanyId) => ({
  type: GET_INPC_BY_ID,
  meta: { needAuth: true },
  payload: Api.inpc.getById(inpcId, companyId, subcompanyId),
});

export const modifyInpc = (payload) => ({ type: MODIFY_EDITING_INPC, payload });

export const addInpc = (companyId, subcompanyId, inpc) => ({
  type: ADD_INPC,
  payload: Api.inpc.add(companyId, subcompanyId, inpc),
});

export const updateInpc = (inpcId, companyId, subcompanyId, inpc) => ({
  type: UPDATE_INPC,
  meta: { id: inpcId, needAuth: true },
  payload: Api.inpc.update(inpcId, companyId, subcompanyId, inpc),
});



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/actions/inpc_actions.js